// ABOUTME: Relation page for the return portal: portal settings, return costs, return reasons and design tabs.
// ABOUTME: The portal tabs and link only show while the warehouse has the portal switched on for the relation.
import { Box, ButtonBase, useTheme } from "@mui/material";
import { useEffect, useMemo, useState } from "react";

import { useTranslation } from "react-i18next";

import { relationReturnsDesignConfig } from "./relationReturnsDesignConfig";

import { useSelector } from "react-redux";
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
// import { transformMap } from "../../../../../components/portalbuilder/componentMaps";
// import { page_keys, } from "../../../../../components/portalbuilder/config";
// import { editOrderLinesConfirmMap, editOrderLinesMap, editRegisterReturnMap, editReturnStatusPageMap, editReturnSubmittedMap } from "../../../../../components/portalbuilder/Mastermaps";
// import EditOrderLinesConfirm from "../../../../../components/portalbuilder/views/EditOrderLinesConfirm";
// import EditOrderLinesToReturn from "../../../../../components/portalbuilder/views/EditOrderLinesToReturn";
// import EditRegisterReturn from "../../../../../components/portalbuilder/views/EditRegisterReturn";
// import EditReturnSubmitted from "../../../../../components/portalbuilder/views/EditReturnSubmitted";
// import EditStatusPage from "../../../../../components/portalbuilder/views/EditStatusPage";
// import TabView3 from "../../../../../components/theme/TabView3/TabView3";
// import { useGetRelationForMenuQuery, useUpdatePortalstyleMutation } from "../../../../../newapi/global/relation/relationSlice";
// import { tokens } from "../../../../../theme";
// import { showToastMessageRequestError, showToastMessageUpdateRequest } from "../../../../../utils/toasts";
import Vormgeving from "./views/Vormgeving";
import { useGetRelationForMenuQuery, useUpdatePortalstyleMutation } from "../../../../newapi/global/relation/relationSlice";
import { tokens } from "../../../../theme";
import { selectEnvironmentid } from "../../../../newapi/global/settingsSlice";
import { ENV_TYPES } from "../../../../components/global/Sidebar";
import { transformMap } from "../../../../components/portalbuilder/componentMaps";
import { showToastMessageRequestError, showToastMessageUpdateRequest } from "../../../../utils/toasts";
import TabView3 from "../../../../components/theme/TabView3/TabView3";
import Text from "../../../../components/theme/text/Text";
import { ShCopyButtonWithOwnChildren } from "../../../../components/theme/ShCopy";
import PortalSettings from "./views/PortalSettings";
import {defaultStyleMap} from './defaultStyleMap';
import ReturnReasons from "./views/ReturnReasons";
import ReturnCosts from "./views/ReturnCosts";
import { selectUserPermission } from "../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from "../../../../utils/permissions";
// import PortalSettings from "./views/PortalSettings";
// import { selectEnvironmentid } from "../../../../../newapi/global/settingsSlice";
// import { ENV_TYPES } from "../../../../../components/global/Sidebar";

const ReturnPortalDesign = (props) => {
    const { t,i18n } = useTranslation();
    
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const environment = useSelector((state) => state.settings.environment);
    const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);
    const {data, isLoading, isFetching} = useGetRelationForMenuQuery(environment.selectedId,{
        skip: selectedEnvironmentType !== ENV_TYPES[200]
    });
    const [transformedData, setTransformedData] = useState(null);
    const [updatePortalstyle,{isLoading:styleUpdating}] = useUpdatePortalstyleMutation();

    const hasReturnPortalPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.RP_RETURN_PORTAL])
    );
    const hasReturnPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.RP_RETURN_READ, UserPrivileges.RP_RETURN_MANAGE])
    );

    // The warehouse switches the portal on per relation; while it is off only the return reasons stay reachable.
    const portalAvailable = data?.settings?.some(setting => setting.key === "return_portal_available" && setting.value === "true") ?? false;
    const showPortal = hasReturnPortalPermission && portalAvailable;

    const tabConfig = useMemo(() => relationReturnsDesignConfig(showPortal, hasReturnPermission), [showPortal, hasReturnPermission]);

    // const selectedEnvironmentId = useSelector(selectEnvironmentid);
    // const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);
    // const {data:data,isFetching:isFetching2,isLoading:isLoading2} = useGetRelationForMenuQuery(selectedEnvironmentId, {
    //     skip: selectedEnvironmentType !== ENV_TYPES[200]
    // });

    // useEffect(() => {
    //     props.replaceView({
    //         ...props.config,
    //     });

    //     return () => {
    //         // console.log("unmounting warehouse");
    //     }
    // },[]);


    useEffect(() => {
      if (!isLoading && !isFetching) {
            if(data?.portalStyle){
                setTransformedData(transformMap(data?.portalStyle));
            } else {
                setTransformedData(defaultStyleMap);
            }
      }
    }, [isLoading, isFetching]);


    const saveDesign = async (key,map) => {
        try{
            if(styleUpdating) return;
            const newMap = {...transformedData};

            const resp = await updatePortalstyle({
                style: newMap
            })
            .unwrap();
            showToastMessageUpdateRequest(t,resp);
        }catch(error){
            showToastMessageRequestError(t("save_design_error"),t,error);
        }
    }
    

    return (
        <Box sx={{background:"", width:1,paddingTop:9}}>
            {showPortal &&
            <Box
                sx={{
                    background:colors.bg["tertiary"],
                    // background:'orange',
                    px:4,
                    width:1,
                    pt:1,
                    pb:3,
                    display:'flex',
                    gap:2,
                }}
            >
                <Box
                    sx={{
                        borderRadius:5,
                        height:40,
                        // background:"orange",
                        background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                        width:1,
                        flex:1,
                        lineHeight:"40px",
                        pl:2.5,
                        display:'flex',
                    }}
                >
                    <Text bold>
                        {"https://www.clicktoreturn.com/"+data?.portalCode}
                    </Text>

                    <ShCopyButtonWithOwnChildren
                        value={"https://www.clicktoreturn.com/"+data?.portalCode}

                        sx={{
                            ml:"auto",
                            alignItems:"center",
                            pr:0.5,
                            // height:40,
                            // px:2,
                            // color:colors.txt["primary"],
                        }}
                    >
                        <ButtonBase
                            sx={{
                                height:32,
                                borderRadius:5,
                                px:2,
                                display:"flex",
                                alignItems:"center",
                                justifyContent:'center',
                                background: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                                color: theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                                fontSize:14,
                                fontWeight:700,
                                fontFamily:"Roboto, sans-serif",
                            }}
                        >
                            {t("copy_link")}
                        </ButtonBase>
                    </ShCopyButtonWithOwnChildren>
                </Box>
                <ButtonBase
                    onClick={() => {
                        if(data) {
                            const href = "https://www.clicktoreturn.com/"+data?.portalCode;
                            window.open(href, '_blank'); // Opens in new tab
                        }
                    }}
                    sx={{
                        height:40,
                        borderRadius:5,
                        px:2,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:'center',
                        background: theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[400],
                        color: theme.palette.mode === "dark" ? colors.txt["light"] : colors.txt["light"],
                        fontSize:14,
                        fontWeight:700,
                        fontFamily:"Roboto, sans-serif",
                    }}
                >
                    <Box sx={{width:24,mr:4}}></Box>
                    {t("view_portal")}
                    <OpenInNewOutlinedIcon sx={{ml:3,color:colors.txt["softened"]}} />
                </ButtonBase>

            </Box>
            }

            <TabView3
                tabConfig={tabConfig}
                // viewType="bodytabs"
                    sx={{
                        background:"green",
                        // minHeight:"calc(100%)",
                        // height: 'calc(100vh - 182px)',
                        minHeight:"calc(100% - 72px)",
                        background: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        position:"relative",
                        zIndex:2,
                        display:"flex",
                        flexDirection:"column",

                        "&:before" : {
                            content: "''",
                            display:"block",
                            width:"32px",
                            height:"32px",
                            position:"absolute",
                            left:0,
                            top:0,
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            top:"40px",
                            height:"48px",
                            width:"24px",
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            transition:"250ms"
                        },

                        "&:after" : {
                            content: "''",
                            display:"block",
                            width:"32px",
                            height:"32px",
                            position:"absolute",
                            top:0,
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            top:"40px",
                            right:0,
                            height:"48px",
                            width:"24px",
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            transform:"scaleX(-1)",
                            transition:"250ms"
                        },

                        "@media screen and (max-width: 47.9375em)" : {
                            "&:after, &:before" : {
                                top:"-0px"
                            }
                        }
                    }}
                // tabClasses={"btn-body-tab"}
            >
                {/* TabView3 picks its tab once, from the first set of tabs; wait for the relation so the portal tabs are known by then */}
                {transformedData !== null && data !== undefined &&
                    <>
                        {showPortal &&
                            <PortalSettings
                                data={data}
                                config={tabConfig.returnportalsettings}
                            />
                        }
                        {showPortal &&
                            <ReturnCosts
                                config={tabConfig.return_costs}
                            />
                        }
                        {hasReturnPermission &&
                            <ReturnReasons
                                config={tabConfig.return_reasons}
                            />
                        }
                        {showPortal &&
                            <Vormgeving
                                config={tabConfig.vormgeving}
                                transformedData={transformedData}
                                setTransformedData={setTransformedData}
                                saveDesign={saveDesign}
                                relationMenuData={data}
                                styleUpdating={styleUpdating}
                            />
                        }
                    </>
                }
            </TabView3>
        </Box>
    )
};

export default ReturnPortalDesign;